import { render } from "./layout-admin.vue?vue&type=template&id=3309f42a"
import script from "./layout-admin.vue?vue&type=script&lang=js"
export * from "./layout-admin.vue?vue&type=script&lang=js"

import "./layout-admin.vue?vue&type=style&index=0&id=3309f42a&lang=scss"

import exportComponent from "/home/runner/work/MBx/MBx/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__